import { Injectable, signal } from '@angular/core';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { HttpClient } from '@angular/common/http';
import { map, Observable, of } from 'rxjs';
import { JobInfo } from './data/jobinfo';
import { JobListResponse } from './data/joblistresponse';
import { MessageService } from './message.service';
import { Collection } from './data/collection';
import { environment } from './../environments/environment';
import { BuiltInProcess } from './explorer/explorersidebar/explorersidebar.component';
import { ProcessInput, TabService } from './tab.service';

@Injectable({
  providedIn: 'root'
})
export class UserService {

  adesUrl = 'https://' + environment.adesPrefix + '.' + environment.domain;
  userInfo: UserInfo|undefined = undefined;
  accessToken: string = '';
  processes = signal<ProcessInfo[]>([]);
  availableBuiltInProcesses: BuiltInProcess[] = [];
  jobs = signal<JobInfo[]>([]);
  userFileCollection: Collection|undefined = undefined;

  builtInProcessesList: BuiltInProcess[] = [
  //  {id: 'vegetationindices-0.0.1', title: 'VegetationIndices', version: '0.0.1', url: '/process_cwl/vegetationindices-0.0.1.cwl', tag:'BASIC'},
  //  {id: 'forestchanges2-0.0.1', title: 'ForestChangeS2', version: '0.0.1', url: '/process_cwl/forestchanges2-0.0.1.cwl', tag:'BASIC'},
  //  {id: 'landcovergeotiff-0.0.1', title: 'LandCoverGeotiff', version: '0.0.1', url: '/process_cwl/landcovergeotiff-0.0.1.cwl', tag:'BASIC'},
  //  {id: 'gdalinfo-0.0.1', title: 'GdalInfo', version: '0.0.1', url: '/process_cwl/gdalinfo-0.0.1.cwl', tag:'BASIC'},
  //  {id: 'gdaltranslate-0.0.1', title: 'GdalTranslate', version: '0.0.1', url: '/process_cwl/gdaltranslate-0.0.1.cwl', tag:'BASIC'},
  //  {id: 'gdalwarp-0.0.1', title: 'GdalWarp', version: '0.0.1', url: '/process_cwl/gdalwarp-0.0.1.cwl', tag:'BASIC'},
  //  {id: 'gdalcalc-0.0.1', title: 'GdalCalc', version: '0.0.1', url: '/process_cwl/gdalcalc-0.0.1.cwl', tag:'BASIC'},
  //  {id: 'fmask40-0.0.1', title: 'Fmask40', version: '0.0.1', url: '/process_cwl/fmask40-0.0.1.cwl', tag:'BASIC'},
  //  {id: 'envimon-0.0.1', title: 'Envimon', version: '0.0.1', url: '/process_cwl/envimon-0.0.1.cwl', tag:'BASIC'},
  //  {id: 'alsmetrics-0.0.1', title: 'ALSMetrics', version: '0.0.1', url: '/process_cwl/alsmetrics-0.0.1.cwl', tag:'BASIC'},
  //  {id: 's1stack-0.0.1', title: 'S1stack', version: '0.0.1', url: '/process_cwl/s1stack-0.0.1.cwl', tag:'BASIC'}
  ];

  constructor(public oidcSecurityService: OidcSecurityService, 
      private http: HttpClient, 
      public messageService: MessageService,
      public tabService: TabService
      ) {
    this.oidcSecurityService.checkAuth().subscribe(({ isAuthenticated, userData, accessToken, idToken}) => {
      console.log(isAuthenticated);
     console.log(userData);
     console.log(accessToken);
     console.log(idToken);
     this.accessToken = accessToken;
 
     if (userData != null) {
      let tags: string[] = [];
      if (userData.description != null) {
        tags = (userData.description as string).split(' ');
      }
      this.userInfo = new UserInfo(userData.preferred_username, userData.email, tags);
      this.userFileCollection = new Collection(
        'metadata:main',
        'User files',
        'Own process results and uploaded data',
        'https://' + environment.resourceCataloguePrefix + '.' 
          + environment.userWorkspacePrefix + userData.preferred_username + '.' + environment.domain + '/stac',
        'https://' + environment.resourceCataloguePrefix + '.' 
          + environment.userWorkspacePrefix + userData.preferred_username + '.' + environment.domain,
        'https://' + environment.resourceCataloguePrefix + '.' 
          + environment.userWorkspacePrefix + userData.preferred_username + '.' + environment.domain + '/stac/queryables',
      );
      this.userFileCollection.sortSupported = false;
      
      console.log(this.userInfo);
      
      this.listProcesses();
      this.getJobs();
     }
    });
 
  }

//  getIdToken(): string|undefined {
//    return this.idToken;
//  }

  getAccessToken(): string|undefined {
    return this.accessToken;
  }

  getUserInfo(): UserInfo|undefined {
    return this.userInfo;
  }

  login() {
    this.oidcSecurityService.authorize();
  }

  logout() {
    this.userInfo = undefined;
    this.processes.set([]);
    this.jobs.set([]);
    this.oidcSecurityService.logoff().subscribe();
    this.userFileCollection = undefined;
  }

  listProcesses():void {
    if (!this.userInfo) {
      return;
    }
    this.http.get<any>(this.adesUrl + '/' + this.userInfo.userName + '/ogc-api/processes', {headers: new HttpHeaders({
      'Authorization': 'Bearer ' + this.accessToken,
      'Accept': 'application/json',
      })}).subscribe({
        next: (data: any) => {
          this.processProcessesResponse(data);
        },
        error: (e) => {
          this.handleError(e, 'Failed to get processes');
        }
    });
  }

  private processProcessesResponse(data:any):void {
      let processes: ProcessInfo[] = [];
      let processesArray = data['processes'];
      let processIds = new Set<string>();
      for (var i=0; i < processesArray.length; i++) {
        if (['display','echo','GetStatus','DeployProcess','UndeployProcess'].includes(processesArray[i].id)) {
          continue;
        }
        let process = new ProcessInfo();
        process.id = processesArray[i].id;
        process.title = processesArray[i].title;
        process.version = processesArray[i].version;
        process.description = processesArray[i].description;
        process.link = processesArray[i].links[0].href;

        processIds.add(process.title.toLowerCase() + '-' + process.version);
        processes.push(process);
      }
      // Sort the processes based on title
      processes.sort((a,b) => (a.title > b.title) ? 1 : ((b.title > a.title) ? -1 : 0));
      this.processes.set(processes);

      this.availableBuiltInProcesses = [];
      this.http.get<BuiltInProcessListResponse>('/process_cwl/processes.json', {headers: new HttpHeaders({
		    'Accept': 'application/json',
        })}).subscribe((data: BuiltInProcessListResponse) => {
          if (data) {
            this.builtInProcessesList = data['processes'];
          }

          console.log(this.builtInProcessesList);
          for (let process of this.builtInProcessesList) {
            //console.log(process);
            if (!processIds.has(process.id)) {
              if (this.userInfo?.tags.includes(process.tag)) {
                this.availableBuiltInProcesses.push(process);
                //console.log('X OK');
              //} else {
              //  console.log(this.userInfo?.tags);
              //  console.log(process.tag);
              }
            }
          }
        });
      

  }

  getProcessInputs(process: ProcessInfo): Observable<ProcessInput[]> {
    if (!this.userInfo) {
      return of([]);
    }
    if (process.link) {
      return this.http.get(process.link, 
        {headers: new HttpHeaders({
            'Authorization': 'Bearer ' + this.accessToken,
            'Accept': 'application/json'})}
        ).pipe(map(data => this.processProcessDetailsResponse(data)));
    }
    return of([]);
  }

  private processProcessDetailsResponse(data:any):ProcessInput[] {
    let inputs: ProcessInput[] = [];

    console.log(data);
    for (let key in data.inputs) {
      data.inputs[key].sortOrder = 0;
      let match = data.inputs[key].description.match(/^\((\d+)\) /);
      if (match) {
        data.inputs[key].sortOrder = Number(match[1]);
        data.inputs[key].description = data.inputs[key].description.replace(/^\((\d+)\) /, '');
      }
      data.inputs[key].tag = key;
      data.inputs[key].fieldids = [ key ];
      inputs.push(data.inputs[key])
    }
    inputs.sort((a,b) => a.sortOrder - b.sortOrder);

    return inputs;
  }

  getProcessDetails(process: ProcessInfo): Observable<any>|null {
    if (!this.userInfo) {
      return null;
    }
    if (process.link) {
      return this.http.get(process.link, 
        {headers: new HttpHeaders({
            'Authorization': 'Bearer ' + this.accessToken,
            'Accept': 'application/json'})}
        );
    }
    return null;
  }

  deployProcess(cwl: string): void {
    if (!this.userInfo) {
      return;
    }

    this.http.post(this.adesUrl + '/' + this.userInfo.userName + '/ogc-api/processes', 
    cwl,
    {headers: new HttpHeaders({
        'Authorization': 'Bearer ' + this.accessToken,
        'Content-Type': 'application/cwl+yaml',
        'Accept': 'application/json'}),
      observe: 'response'}
    ).subscribe({
      next: (resp) => {
        if (resp.status == 201) {
          this.messageService.addMessage('Deployed process ' + resp.headers.get('location'));
        } else {
          this.messageService.addMessageAndNotify('Error', 'Failed to deploy process (HTTP response ' + resp.status.toString() + ' ' + resp.statusText + ')');
        }
        this.listProcesses();
      },
      error: (e) => {
        this.handleError(e, 'Failed to deploy process');
      }
    });
  }

  undeployProcess(process: ProcessInfo): void {
    if (!this.userInfo) {
      return;
    }
    if (process.link) {
      this.http.delete(process.link,
        {headers: new HttpHeaders({
            'Authorization': 'Bearer ' + this.accessToken,
            'Accept': 'application/json'
          }),
          observe: 'response'}
        ).subscribe({
          next: (resp) => {
            console.log(resp);
            const keys = resp.headers.keys();
            if (resp.status == 204) {
              this.messageService.addMessage('Undeployed process ' + process.id);
            } else {
              this.messageService.addMessageAndNotify('ERROR', 'Failed to undeploy process (HTTP response ' + resp.status.toString() + ' ' + resp.statusText + ')');
            }
            this.listProcesses();
          },
          error: (e) => {
            this.handleError(e, 'Failed to undeploy process');
          }
      });
    }
  }

  launchProcess(process: ProcessInfo, data: any): void {
    if (!this.userInfo) {
      return;
    }
    if (process.link) {
      this.http.post(process.link + '/execution', data,
        {headers: new HttpHeaders({
            'Authorization': 'Bearer ' + this.accessToken,
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'Prefer': 'respond-async'}),
          observe: 'response'}
        ).subscribe({
          next: (resp) => {
            //console.log(resp);
            const keys = resp.headers.keys();
            if (resp.status == 201) {
              this.messageService.addMessage('Started job ' + (resp.body as any)['jobID']);
              this.getJobs();
              this.tabService.showBottomViewJobs();
            } else {
              this.messageService.addMessageAndNotify('ERROR', 'Failed to start job (HTTP response ' + resp.status.toString() + ' ' + resp.statusText + ')');
              this.tabService.showBottomViewMessages();
            }
        },
        error: (e) => {
          this.handleError(e, 'Failed to start job');
        }
    });
    }
  }

  getJobs(): void {
    if (!this.userInfo) {
      return;
    }
    this.http.get<JobListResponse>(this.adesUrl + '/' + this.userInfo.userName + '/ogc-api/jobs', {headers: new HttpHeaders({
      'Authorization': 'Bearer ' + this.accessToken,
      'Accept': 'application/json',
      })}).subscribe({
        next: (data: JobListResponse) => {
          // Add default wmsopacity
          data.jobs.forEach(x => x.wmsopacity = 1.0);
          // Sort the jobs based on created timestamp
          data.jobs.sort((a,b) => (a.created > b.created) ? -1 : ((b.created > a.created) ? 1 : 0));
          for (let j of data.jobs){
            if (j.status == 'running' && 
              (j.message.startsWith('Unable to run the Service') || j.message.startsWith('ZOO-Kernel successfully run your service!'))) {
              j.message = '';
            }
          }
          this.jobs.set(data.jobs);
        },
        error: (e) => {
          this.handleError(e, 'Failed to get jobs');
        }
    });
  }

  deleteJob(jobId:string): void {
    if (!this.userInfo) {
      return;
    }
    this.http.delete(this.adesUrl + '/' + this.userInfo.userName + '/ogc-api/jobs/' + jobId, 
      {
        headers: new HttpHeaders({
          'Authorization': 'Bearer ' + this.accessToken,
          'Accept': 'application/json'}), 
        observe: 'response'
      }
      ).subscribe({
        next: (resp) => {
          if (resp.status == 200) {
            this.messageService.addMessage('Deleted job ' + jobId);
            this.getJobs();
          } else {
            this.messageService.addMessageAndNotify('ERROR', 'Failed to delete job ' + jobId + ' (HTTP response ' + resp.status.toString() + ' ' + resp.statusText + ')');
          }
      },
        error: (e) => {
          this.handleError(e, 'Failed to delete job ' + jobId);
        }
    });
  }

  getJobResult(jobId:string): Observable<any>|null {
    if (!this.userInfo) {
      return null;
    }
    return this.http.get(this.adesUrl + '/' + this.userInfo.userName + '/ogc-api/jobs/' + jobId + '/results', 
      {
        headers: new HttpHeaders({
          'Authorization': 'Bearer ' + this.accessToken,
          'Accept': 'application/json'})
      }
      );
  }

  getStacCollectionItems(collectionId:string): Observable<any>|null {
    if (!this.userInfo) {
      return null;
    }
    let url = 'https://' + environment.resourceCataloguePrefix + '.' 
      + environment.userWorkspacePrefix + this.userInfo.userName + '.'
      + environment.domain 
      + '/stac/collections/' + collectionId + '/items';    
    return this.http.get(url, 
      {
        headers: new HttpHeaders({
          'Authorization': 'Bearer ' + this.accessToken,
          'Accept': 'application/json'})
      }
      );
  }

  getServerSlds(): Observable<any>|null {
    if (!this.userInfo) {
      return null;
    }
    return this.http.get('/app/assets/slds.json', 
      {headers: new HttpHeaders({
          'Authorization': 'Bearer ' + this.accessToken,
          'Accept': 'application/json'})}
      );
  }

  handleError(error: HttpErrorResponse, description:string) {
    if (error.status === 0) {
      // A client-side or network error occurred. Handle it accordingly.
      //console.error('An error occurred:', error.error);
      this.messageService.addMessageAndNotifyError(error, description);
    } else {
      // The backend returned an unsuccessful response code.
      // The response body may contain clues as to what went wrong.
      //console.error(`Backend returned code ${error.status}, body was: `, error.error);
      this.messageService.addMessageAndNotifyError(error, description);
    }
  }
}

export interface BuiltInProcessListResponse {
  processes: BuiltInProcess[];
}

export class ProcessInfo {
  public id: string = '';
  public title: string = '';
  public description: string = '';
  public version: string = '';
  public link: string = '';
}

export class UserInfo {
  public userName: string = '';
  public email: string = '';
  public tags: string[] = [];
  
  constructor(userName: string, email: string, tags: string[]) {
    this.userName = userName;
	  this.email = email;
    this.tags = tags;
  }
}
